const vocationalSchoolId = 1022;
const vocationalSchoolName = "Fagskoler";

export const useIsVocationalSchool = (mainCourse?: number | string) => {
  if (typeof mainCourse === "string") {
    return mainCourse === vocationalSchoolName;
  }
  return mainCourse === vocationalSchoolId;
};
